export default __webpack_public_path__ + "static/media/document-icon.4bea10cf.svg";